const TextAreaField = ({
  label,
  name,
  value,
  compulsory = false,
  error,
  ...props
}) => (
  <div className="form-group mt-3">
    <label className="label">{label}</label>
    <div className="flex">
      <textarea name={name} value={value} className="textarea" {...props} />
      {compulsory && <span className="label-imp">*</span>}
    </div>
    {error && <p className="label-error">{error}</p>}
  </div>
);

export default TextAreaField;
